import { Pipe, PipeTransform } from '@angular/core';
import { concat } from 'rxjs';

@Pipe({
  name: 'substringText'
})
export class SubstringTextPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if( (value === undefined) || (value === "") || (value === null)){
      return null;
    } else {
      return value.substring(0, 20).concat('...');
    }
  }

}
